// extracted by mini-css-extract-plugin
export default {"title":"NotFound_title__tmc1N"};